<template>
  <v-row dense class="ma-6 flex" justify="space-around">
    <v-col
      v-for="card in cards"
      :key="card.title"
      :cols="card.flex"
    >
      <v-card elevation="6">
        <v-card-title v-text="card.title" class="primary white--text text-caption text-lg-button text-md-subtitle-2 text-sm-caption text-no-wrap"></v-card-title>
        <v-img
          :src="card.src"
          class="black--text"
          height="200px"
          contain
        >
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon @click="doRefSelected(card)">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import { UI_ADD_ACTION, UI_SET_ACTIONS } from '@/store/actions/ui'

export default {
  name: 'sysReferencesList',
  props: ['accessKey'],
  components: {
  },
  data () {
    return {
      renewAction: { text: 'Обновить справочники', actionType: 'Управление справочниками', action: 'viewAgreement', method: this.renewReferences, icon: 'mdi-cloud-refresh' },
      selectedReference: {},
      cards: [
        { guid: 'forms/refGOST2FTList', title: 'ГОСТы, по типам топлива', src: '/static/images/gost.jpg', flex: 4, global: true, dl: false },
        { guid: 'forms/refFuelGradesList', title: 'Марки топлива по ГОСТ', src: '/static/images/fuel_kinds.png', flex: 4, global: true, dl: false },
        { guid: 'refOKEITable', title: 'Единицы измерения, ОКЕИ', src: '/static/images/scales.png', flex: 4, global: true, dl: false },
        { guid: 'forms/refMULocalList', title: 'Единицы измерения, локальный', src: '/static/images/ref_MU.png', flex: 4, global: false, dl: true },
        { guid: 'forms/refComponentsList', title: 'Компоненты', src: '/static/images/flask_empty.png', flex: 4, global: false, dl: true },
        { guid: 'forms/refOrgPropertiesList', title: 'Физико-химические свойства', src: '/static/images/CMD1.jpg', flex: 4, global: false, dl: true }
        // { guid: 'sysGOST_docs', title: 'ГОСТы, глобальный', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 4, global: true, dl: false },
      ]
    }
  },
  computed: {},
  mounted: function () {
    console.log('references::orgReferences::index mounted')
    this.setActions()
  },
  watch: {
    accessKey (val) {
      console.log('Called for accessKey ', val)
      if (val !== 'sysReferences') {
        this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Управление справочниками' })
      } else {
        this.setActions()
      }
    }
  },
  methods: {
    doRefSelected (val) {
      console.log('refList component sending compSignal')
      this.selectedReference = val
      const payload = {
        comp: 'sysReferences',
        data: {
          ref_guid: val.guid,
          reference_name: val.title
        }
      }
      this.$emit('compSignal', payload)
    },

    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, {})
      this.$store.dispatch(UI_ADD_ACTION, this.renewAction)
    },
    renewReferences () {
    }
  }
}
</script>
